import script from "./Avvio.vue?vue&type=script&setup=true&lang=js"
export * from "./Avvio.vue?vue&type=script&setup=true&lang=js"

import "./Avvio.vue?vue&type=style&index=0&id=6b2d91ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2d91ea"]])

export default __exports__